export const environment = {
  production: true,
  apiUrl: 'https://beta.dawamt.com/api/support-agent/',
  chatUrl: 'https://chat.dawamt.com/',
  appName: 'DAWMT Support Beta',
  version: '1.0.0',
  enableDebug: false,
  firebase: {
    apiKey: "AIzaSyCtl0ogb06_sVL9JZAfBbVfKesvfMVBTgs",
    authDomain: "dawamt-df360.firebaseapp.com",
    databaseURL: "https://dawamt-df360.firebaseio.com",
    projectId: "dawamt-df360",
    storageBucket: "dawamt-df360.firebasestorage.app",
    messagingSenderId: "1051833427998",
    appId: "1:1051833427998:web:da89fafaec658b1f99e60f",
    measurementId: "G-5Z1Q9P8C1Y"
  },
};
